import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class ReservationLabelsController extends ApplicationComponent {
  constructor(props) {
    super(props)

    this.state = {
      reservationLabelsEnabled: this.props.reservationLabelsEnabled,
      loadingReservationLabelCheckbox: false,
      color: "",
      customLabel: "",
      addingLabel: false,
      savingLabel: false,
      showModal: false,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this)
    this.toggleReservationLabels = this.toggleReservationLabels.bind(this)
    this.editLabel = this.editLabel.bind(this)
    this.cancel = this.cancel.bind(this)
    this.deleteLabel = this.deleteLabel.bind(this)
  }

  toggleReservationLabels(boolean) {
    this.setState({ loadingReservationLabelCheckbox: true })
    return $.patch(
      this.props.toggleReservationLabelsRoute,
      { map_reservation_labels_enabled: boolean },
      (data) => {
        this.setState({
          reservationLabelsEnabled: data,
          loadingReservationLabelCheckbox: false,
        })
      }
    )
  }

  handleCheckBoxChange(event) {
    this.setState({ loadingReservationLabelCheckbox: true })
    this.toggleReservationLabels(event.target.checked)
  }

  handleSubmit() {
    if (this.validator.allValid()) {
      const params = {
        label: this.state.customLabel,
        color: this.state.color,
      }
      this.setState({ savingLabel: true })
      if (this.state.editingLabel) {
        params.id = this.state.editingLabel.id
        $.patch(
          `${this.props.reservationLabelsRoute}/${params.id}`,
          params,
          () => {
            window.location.reload()
          }
        ).fail(() => this.setState({ savingLabel: false }))
      } else {
        $.post(this.props.reservationLabelsRoute, params, () => {
          window.location.reload()
        }).fail(() => this.setState({ savingLabel: false }))
      }
    } else {
      this.validator.showMessages()
    }
  }

  deleteLabel() {
    this.setState({ savingLabel: true })
    $.delete(
      `${this.props.reservationLabelsRoute}/${this.state.editingLabel.id}`,
      { id: this.state.editingLabel.id },
      () => {
        window.location.reload()
      }
    ).fail(() => {
      alert(
        "Unable to delete label, please try again or contact support if the issue persists."
      )
      this.setState({ savingLabel: false })
    })
  }

  colorsLeft() {
    const existingLabelColors = _.map(this.props.reservationLabels, (label) => {
      return label.color
    })
    if (!_.isEmpty(existingLabelColors)) {
      return _.filter(
        this.props.reservationLabelColorNames,
        (color) =>
          !existingLabelColors.includes(color) ||
          (this.state.editingLabel && this.state.editingLabel.color === color)
      )
    } else {
      return this.props.reservationLabelColorNames
    }
  }

  cancel() {
    this.setState({
      addingLabel: false,
      editingLabel: "",
      color: "",
      customLabel: "",
      showModal: false,
    })
  }

  editLabel(label) {
    this.setState({
      addingLabel: true,
      editingLabel: label,
      color: label.color,
      customLabel: label.label,
    })
  }

  renderDeleteModal() {
    return (
      <Modal isOpen={this.state.showModal} onClose={this.cancel} size="small">
        <Modal.Header title={`Delete "${this.state.editingLabel.label}"?`} />
        <Modal.Body>
          <p>
            Deleting this label will remove it from{" "}
            {pluralize(
              "reservation",
              this.state.editingLabel.reservationCount,
              true
            )}
            , are you sure you want to continue?
          </p>
        </Modal.Body>
        <Modal.Footer
          cancelBtnText="Cancel"
          confirmBtnText="Delete"
          confirmBtnVariant="danger"
          onClose={this.cancel}
          onSubmit={this.deleteLabel}
          confirmBtnLoading={this.state.savingLabel}
        />
      </Modal>
    )
  }

  renderBlankState() {
    return (
      <div className="bg-gray mt-2 flex h-96 w-full content-center justify-center rounded">
        <div className="flex w-96 flex-col justify-center text-center">
          <h4 className="leading-relaxed">
            Customize your reservations just the way you want with custom labels
            and colors.
          </h4>
          <div className="flex justify-center">
            <LegacyButton
              type="primary"
              processing={this.state.loadingReservationLabelCheckbox}
              processingText=" "
              onClick={() => this.toggleReservationLabels(true)}
              className="w-32"
            >
              Get Started
            </LegacyButton>
          </div>
        </div>
      </div>
    )
  }

  renderReservationLabelHeader() {
    return (
      <div className="flex flex-col">
        <h4>Marina Map Color Coding</h4>
        <p>
          Set up to {this.props.reservationLabelColorNames.length} different
          labels (examples: short term, long term, liveaboard) and associate
          them with a color to represent reservation types. You can apply labels
          to specific reservations from the{" "}
          <a href={this.props.assignmentsRoute} className="link font-bold">
            Assignments
          </a>{" "}
          view.
        </p>
        {this.state.reservationLabelsEnabled ? (
          <div className="flex flex-row">
            <FormGroup
              inputType="checkbox"
              name="reservationLabelCheckbox"
              value={this.state.reservationLabelsEnabled}
              onChange={this.handleCheckBoxChange}
              className="my-0"
              disabled={this.state.loadingReservationLabelCheckbox}
              label="Use custom labels and colors"
            />
            <i
              className="icon icon-info ml-1 mt-0.5 cursor-pointer text-xs text-gray-500"
              data-container="body"
              data-toggle="popover"
              data-placement="top"
              data-content="This box must be checked in order to use custom labels on reservations"
            />
            {this.state.loadingReservationLabelCheckbox ? (
              <span>
                <i className="icon icon-spinner icon-spin ml-2 text-gray-600" />
              </span>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  }

  renderPreview(color) {
    return (
      <div>
        <label>Preview</label>
        <div className="mt-1 flex flex-row">
          <div
            className={`-mt-1 mr-2 h-7 w-7 rounded-full text-center rl-bg-${color}-dark`}
          >
            <i className="icon icon-check mt-2" />
          </div>
          <p className="mr-2">Checked-in</p>
          <div
            className={`-mt-1 mr-2 h-7 w-7 rounded-full text-center rl-bg-${color}-light`}
          />
          <p>Confirmed</p>
        </div>
      </div>
    )
  }

  renderReservationLabels() {
    if (!_.isEmpty(this.props.reservationLabels)) {
      return _.map(this.props.reservationLabels, (label, index) => {
        return this.state.editingLabel === label && !this.state.showModal ? (
          this.renderReservationLabelForm(index)
        ) : (
          <div
            key={index}
            className="row form-row mb-4 rounded border px-3 pb-1 pt-3"
          >
            <div className="col-sm-3">
              <label>Label Name</label>
              <div className="mt-1 flex flex-row">
                <div
                  className={`mr-1 h-5 w-5 rounded-full text-center rl-bg-${label.color}-dark`}
                />
                <p>{label.label}</p>
              </div>
            </div>
            <div className="col-sm-8">{this.renderPreview(label.color)}</div>
            <div className="col-sm-1 mt-1 flex justify-end">
              <LegacyButton
                type="secondary"
                onClick={() => this.editLabel(label)}
              >
                Edit
              </LegacyButton>
            </div>
          </div>
        )
      })
    }
  }

  renderReservationLabelForm(index) {
    return (
      <div key={index} className="row form-row mb-4 rounded border px-4 pt-4">
        <button
          type="button"
          className="close -mr-1 -mt-4 text-2xl"
          onClick={this.cancel}
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="col-sm-3">
          <FormGroup
            label="Label Name"
            placeholder="Your Label"
            name="customLabel"
            value={this.state.customLabel}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "custom label",
              this.state.customLabel,
              "required"
            )}
          />
        </div>
        <div className="col-sm-3">
          <FormGroup
            inputType="select"
            label="Color"
            name="color"
            value={this.state.color}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "color",
              this.state.color,
              "required"
            )}
          >
            <option value="" disabled="true" className="text-muted">
              Select Color
            </option>
            {_.map(this.colorsLeft(), (color, index) => {
              return (
                <option key={index} value={color}>
                  {capitalizeFirstLetter(color)}
                </option>
              )
            })}
          </FormGroup>
        </div>
        <div className="col-sm-4 flex justify-center">
          {this.state.color ? this.renderPreview(this.state.color) : null}
        </div>
        <div className="col-sm-2">
          <div className="mt-1 flex flex-row justify-end">
            {this.state.color ? (
              <div className="flex flex-row">
                <LegacyButton
                  type="primary"
                  processing={this.state.savingLabel && !this.state.showModal}
                  processingText={
                    this.state.editingLabel ? "Updating" : "Saving"
                  }
                  onClick={this.handleSubmit}
                >
                  {this.state.editingLabel ? "Update" : "Save"}
                </LegacyButton>
                {this.state.editingLabel ? (
                  <LegacyButton
                    type="tertiary"
                    className="ml-2"
                    disabled={this.state.savingLabel}
                    onClick={() =>
                      this.setState({
                        showModal: true,
                        editingLabel: this.state.editingLabel,
                      })
                    }
                  >
                    Delete
                  </LegacyButton>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  renderReservationLabelTable() {
    return (
      <div>
        <div className="p-2">
          {this.renderReservationLabels()}
          {this.state.addingLabel && !this.state.editingLabel
            ? this.renderReservationLabelForm()
            : null}
        </div>
        {!this.state.addingLabel &&
        !this.state.editingLabel &&
        !_.isEmpty(this.colorsLeft()) ? (
          <div className="flex justify-end px-1">
            <LegacyButton
              type="primary"
              onClick={() => this.setState({ addingLabel: true })}
            >
              Add Label
            </LegacyButton>
          </div>
        ) : null}
      </div>
    )
  }

  render() {
    return (
      <div className="mt-6">
        {this.renderReservationLabelHeader()}
        {this.state.reservationLabelsEnabled
          ? this.renderReservationLabelTable()
          : this.renderBlankState()}
        {this.state.showModal ? this.renderDeleteModal() : null}
      </div>
    )
  }
}

// Missing helper function in the code
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// Missing pluralize function
function pluralize(word, count, includeCount = false) {
  const pluralizedWord = count === 1 ? word : `${word}s`
  return includeCount ? `${count} ${pluralizedWord}` : pluralizedWord
}

ReservationLabelsController.propTypes = {
  reservationLabelsEnabled: PropTypes.bool.isRequired,
  reservationLabels: PropTypes.array.isRequired,
  reservationLabelColorNames: PropTypes.array.isRequired,
  toggleReservationLabelsRoute: PropTypes.string.isRequired,
  reservationLabelsRoute: PropTypes.string.isRequired,
  assignmentsRoute: PropTypes.string.isRequired,
}

export default ReservationLabelsController
